export default __webpack_public_path__ + "static/media/offline.2c557641.svg";